import {ROOT_PROJECT_ID, stringifyId} from '../../../../types'
import type {BuildId} from '../../../../types'
import type {ProblemOccurrencesTreeNode} from '../BuildProblems.types'

export const getProblemOccurrencesLocator = (buildId: BuildId): string =>
  `build:(id:${stringifyId(buildId)}),type:(snapshotDependencyProblem:false)`

export const getProblemRootCausesLocator = (buildId: BuildId): string =>
  `build:(snapshotDependencyProblem:(includeInitial:true,to:(id:${stringifyId(
    buildId,
  )}))),type:(snapshotDependencyProblem:false)`

export const getRootNode = (
  nodes: ReadonlyArray<ProblemOccurrencesTreeNode> | undefined | null,
): ProblemOccurrencesTreeNode | undefined | null =>
  nodes?.find(node => node.name === ROOT_PROJECT_ID)
